/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Page_AsideInputs */

const en_shop_page_aside = /** @type {(inputs: Shop_Page_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides, plans and gear from your trainer, bought in a minute.`)
};

const pl_shop_page_aside = /** @type {(inputs: Shop_Page_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poradniki, plany i sprzęt od Twojego trenera, kupione w minutę.`)
};

/**
* | output |
* | --- |
* | "Guides, plans and gear from your trainer, bought in a minute." |
*
* @param {Shop_Page_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_page_aside = /** @type {((inputs?: Shop_Page_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Page_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_page_aside(inputs)
	return en_shop_page_aside(inputs)
});